
export const styleGuideUrl = 'http://elements-t.cloudapps.local.ergodirekt.de/version/6.4.0/';
export const elementsVersion = '6.4.0';
